import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { BodyContainer, Title, TitleContainer, DescriptionContainer, Description, Email } from './mixins'
import PopOver from '../index'
import { atcEcommerce } from '../../../../constants/contact'
import { SITE_ID } from '../../../../constants'
import { AppStore } from '../../../../store'
import { useFadeNotification } from '../../../../hooks/fade-notification-hook'
import { hideNotificationCart } from '../../../../store/cart-v2/notification/actionsToDo'
import { NotificationCartState } from '../../../../store/cart-v2/notification/types'

const Component = () => {
  const { open } = useSelector<AppStore, NotificationCartState>(({ cartStoreV2 }) => cartStoreV2.notification)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const onClose = useCallback(() => dispatch(hideNotificationCart()), [])

  const { execute } = useFadeNotification({ timer: 10000, callback: onClose })

  useEffect(() => {
    open && execute()
  }, [open])

  return (
    <PopOver isOpen={open} onClose={onClose}>
      <BodyContainer>
        <TitleContainer>
          <Icon name="icon-light-alert-triangle" size="32" color="#EC0000" />
          <Title>{t('cart.notification.error.title')}</Title>
        </TitleContainer>
        <DescriptionContainer>
          <Description>{t('cart.notification.error.description')}</Description>
          <Email>{atcEcommerce[SITE_ID || 'BMAR'].email}</Email>
        </DescriptionContainer>
      </BodyContainer>
    </PopOver>
  )
}

export default Component
